"use strict";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = require("./shams");
module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") {
        return false;
    }
    if (typeof Symbol !== "function") {
        return false;
    }
    if (_type_of(origSymbol("foo")) !== "symbol") {
        return false;
    }
    if (_type_of(Symbol("bar")) !== "symbol") {
        return false;
    }
    return hasSymbolSham();
};
